/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import axios from "axios";
import cookie from "react-cookies";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, frontURL, clientheaderconfig, ecommerceapiUrl } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isEmail,
  isPhone,
  isNumber,
  isSingleSelect,
  uploadFile,
  removeFile,
  loadAvailabilty,
  loadTATList,
  loadOutletTagList,
} from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";
import PageLoader from "../../Helpers/PageLoader";
import Googlemap from "./Googlemap";
var module = "outlet";
var moduleName = "Outlet";
var modulePath = "/clientpanel/outlet";
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || '',
      pageloading: false,
      clientdata: {
        outletName: "",
        outletPOSID: "",
        outletPhone: "",
        outletOrderNotifyEmail: "",
        outletPostalCode: "",
        outletUnitNumber: "",
        outletFloorNumber: "",
        outletAddress: "",
        outletLatitude: "",
        outletLongitude: "",
        outletAvailability: [],
        outletTagID: [],
        outletDeliveryTAT: "",
        outletPickupTAT: "",
        outletDineInTAT: "",
        outletSequence: "",
        outletMapLink: "",
        outletTimeInfo: "",
        outletOfferInfo: "",
        outletPerdayLimit: "",
        outletInformation: "",
        outletImage: "",
        outletStatus: "",
        outletQRCodeImage: "",
        outletReviewQR: "",
        outletWhatsAppQR: "",
        outletWhatsAppURL: "",
        outletWhatsAppReviewQR: "",
        outletWhatsAppReviewURL: "",
        outletSpinWheelQR: "",
        outletSpinWheelURL: "",
        outletscratchcardQR: "",
        outletscratchcardURL: "",        
        outletslug: "",
        outletQRCode: "",
        outletPlaceID: "",
        outletValidateDistance: "10",
      },
      btndisabled: false,
      loading: true,
      availabiltyList: [],
      tatList: [],
      tagList: [],
      formpost: [],
      companyDetail: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount = async () => {
    const availabiltyList = await loadAvailabilty();
    const tatList = await loadTATList();
    const tagList = await loadOutletTagList();
    this.setState({
      availabiltyList: availabiltyList,
      tatList: tatList,
      tagList: tagList,
    });
    //this.loadAvailabilty();
    if (this.state.editID !== "") {
      var params = {
        url: `${apiUrl}${module}/details/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost != nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0]?.message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.navigate(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var outletStatus = result.outletStatus == 1 ? "Open" : "Closed";
          var status =
            result.outletStatus !== "" && result.outletStatus !== null
              ? {
                label: outletStatus,
                value: result.outletStatus,
              }
              : "";
          const outletDeliveryTAT = result?.outletDeliveryTAT
            ? {
              label: result.outletDeliveryTAT,
              value: result.outletDeliveryTAT,
            }
            : "";
          const outletPickupTAT = result?.outletPickupTAT
            ? {
              label: result.outletPickupTAT,
              value: result.outletPickupTAT,
            }
            : "";
          const outletDineInTAT = result?.outletDineInTAT
            ? {
              label: result.outletDineInTAT,
              value: result.outletDineInTAT,
            }
            : "";

          var clientupdatedata = {
            outletName: result.outletName,
            outletPOSID: result.outletPOSID,
            outletPhone: result.outletPhone,
            outletOrderNotifyEmail: result.outletOrderNotifyEmail,
            outletPostalCode: result.outletPostalCode,
            outletUnitNumber: result.outletUnitNumber,
            outletFloorNumber: result.outletFloorNumber,
            outletAddress: result.outletAddress,
            outletLatitude: result?.outletLatitude || "",
            outletLongitude: result?.outletLongitude || "",
            outletAvailability: [],
            outletDeliveryTAT: outletDeliveryTAT,
            outletPickupTAT: outletPickupTAT,
            outletDineInTAT: outletDineInTAT,
            outletSequence: result.outletSequence,
            outletPerdayLimit: result.outletPerdayLimit,
            outletMapLink: result.outletMapLink,
            outletTimeInfo: result.outletTimeInfo,
            outletOfferInfo: result.outletOfferInfo,
            outletInformation: result.outletInformation !== "" && result.outletInformation !== null ? result.outletInformation : "",
            outletImage: result?.outletImage || "",
            outletStatus: status,
            outletQRCodeImage: result.outletQRCodeImage !== "" && result.outletQRCodeImage !== null ? result.outletQRCodeImage : "",
            outletReviewQR: result.outletReviewQR !== "" && result.outletReviewQR !== null ? result.outletReviewQR : "",
            outletWhatsAppQR: result.outletWhatsAppQR !== "" && result.outletWhatsAppQR !== null ? result.outletWhatsAppQR : "",
            outletWhatsAppURL: result.outletWhatsAppURL !== "" && result.outletWhatsAppURL !== null ? result.outletWhatsAppURL : "",
            outletWhatsAppReviewQR: result.outletWhatsAppReviewQR !== "" && result.outletWhatsAppReviewQR !== null ? result.outletWhatsAppReviewQR : "",
            outletWhatsAppReviewURL: result.outletWhatsAppReviewURL !== "" && result.outletWhatsAppReviewURL !== null ? result.outletWhatsAppReviewURL : "",
            outletSpinWheelQR: result.outletSpinWheelQR !== "" && result.outletSpinWheelQR !== null ? result.outletSpinWheelQR : "",
            outletSpinWheelURL: result.outletSpinWheelURL !== "" && result.outletSpinWheelURL !== null ? result.outletSpinWheelURL : "",
            outletslug: result?.outletslug || "",
            outletQRCode: result?.outletQRCode || "",
            outletPlaceID: result?.outletPlaceID || "",
            outletValidateDistance: result?.outletValidateDistance || "10",
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false }, () => {
            this.loadOutletDetails();
          });
        } else {
          this.setState({ pageloading: false });
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid " + moduleName, "error");
        }
      });
    }
  }
  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };
  loadOutletDetails = async () => {
    const urlShringTxt = `${ecommerceapiUrl}${module}/detail/${this.state.editID}`;
    const { data } = await axios.get(urlShringTxt, clientheaderconfig);
    if (data.status === "ok") {
      const result = data.result;
      var outletAvailability = result?.outletAvailability ?? [];
      var outletTagID = result?.outletTagID ?? [];
      this.setState(
        update(this.state, {
          clientdata: {
            outletAvailability: { $set: outletAvailability },
            outletTagID: { $set: outletTagID },
          },
        })
      );
    }
  };
  handleChange(checked, name) {
    this.setState({ checked });
  }
  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { clientdata: { [field]: { $set: value } } }), () => {
      if (field === "outletPostalCode") {
        if (value.length === 6) {
          this.getAddress(value);
        }
      }
    });
  };

  getAddress(zipcode) {
    const postObject = {
      zipcode: zipcode,
    };
    axios
      .post(apiUrl + "common/zipCode", postObject, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("clientAccessToken")}`,
        },
      })
      .then((res) => {
        if (res.data.status === "ok") {
          var result = res.data.result;
          this.setState(
            update(this.state, {
              clientdata: {
                outletUnitNumber: { $set: result.zip_buno },
                outletAddress: { $set: result.zip_sname },
                /* outletLatitude: { $set: result.zip_latitude },
                outletLongitude: { $set: result.zip_longitude }, */
              },
            })
          );
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;
    var outletAvailability = postData.outletAvailability.length > 0 ? postData.outletAvailability.map((item) => item.value) : [];
    var outletTagID = postData.outletTagID.length > 0 ? postData.outletTagID.map((item) => item.value) : [];
    /* alert($('#editorContent').val());
    return false; */
    const editorContent = $("#editorContent").val();
    var postObject = {
      outletName: postData.outletName,
      outletPOSID: postData.outletPOSID,
      outletPhone: postData.outletPhone,
      outletOrderNotifyEmail: postData.outletOrderNotifyEmail,
      outletPostalCode: postData.outletPostalCode,
      outletUnitNumber: postData.outletUnitNumber,
      outletFloorNumber: postData.outletFloorNumber,
      outletAddress: postData.outletAddress,
      outletLatitude: postData.outletLatitude,
      outletLongitude: postData.outletLongitude,
      outletDeliveryTAT: postData?.outletDeliveryTAT?.value ?? "",
      outletPickupTAT: postData?.outletPickupTAT?.value,
      outletDineInTAT: postData?.outletDineInTAT?.value,
      outletAvailability: outletAvailability.length > 0 ? outletAvailability.join(",") : "",
      outletTagID: outletTagID.length > 0 ? outletTagID.join(",") : "",
      outletSequence: postData.outletSequence,
      outletInformation: editorContent,
      outletImage: postData.outletImage,
      outletStatus: postData.outletStatus?.value,
      outletPlaceID: postData.outletPlaceID,
      outletValidateDistance: postData.outletValidateDistance,
      outletPerdayLimit: postData.outletPerdayLimit,
      outletMapLink: postData.outletMapLink,
      outletTimeInfo: postData.outletTimeInfo,
      outletOfferInfo: postData.outletOfferInfo,
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"outlet"} />
          <div className="layout-page">
            <Topmenu />
            <ToastContainer />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{this.state.editID !== "" ? "Update" : "Add New"} Outlet</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <Postform
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  availabiltyList={this.state.availabiltyList}
                  tatList={this.state.tatList}
                  tagList={this.state.tagList}
                  onChange={this.fieldChange}
                  sateValChange={this.sateValChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 160,
                          },
                          100
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { outletName, outletPhone, outletOrderNotifyEmail, outletPostalCode, outletStatus } = props.fields;

  return {
    fields: ["outletName", "outletPhone", "outletOrderNotifyEmail", "outletPostalCode", "outletStatus"],

    validations: {
      outletName: [[isEmpty, outletName]],
      outletPhone: [[isPhone, outletPhone]],
      outletOrderNotifyEmail: [[isEmail, outletOrderNotifyEmail]],
      outletPostalCode: [
        [isEmpty, outletPostalCode],
        [isNumber, outletPostalCode],
      ],
      outletStatus: [[isSingleSelect, outletStatus]],
    },
  };
}

class Postform extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modleType: "",
    };
    this.setContent = this.setContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  setContent(value) {
    this.props.onChange("outletInformation", value);
  }
  async uplaodoutletImage(imageType) {
    this.props.sateValChange("btndisabled", true);
    showLoader("ImageDetails");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#" + imageType);
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "outlet", "client", "epicpay");
    if (fileDetail.status === "ok") {
      this.props.onChange(imageType, fileDetail.url);
    }
    hideLoader("ImageContainer");
    hideLoader("ImageDetails");
    $("#" + imageType).val("");
    this.props.sateValChange("btndisabled", false);
  }

  async removeImage(fileNamme, imageType, e) {
    e.preventDefault();
    showLoader("ImageDetails", "class");
    var fileDetail = await removeFile(fileNamme, "client", "epicpay");
    if (fileDetail.status === "ok") {
      hideLoader("ImageDetails", "class");
      this.props.onChange(imageType, "");
    }
  }

  copyLink(itemSlug) {
    toast.success("Link Copied Success", { autoClose: 1000 });
    navigator.clipboard.writeText(itemSlug);
  }
  viewQRCode(modleType, e) {
    e.preventDefault();
    this.setState({ modleType: modleType }, () => {
      $("#customermodal").modal("toggle");
    });
  }
  sateValChange = (field, value) => {
    if (field === "latlong") {
      const outletLatitude = value.lat;
      const outletLongitude = value.lng;
      this.props.onChange('outletLatitude', outletLatitude)
      setTimeout(() => {
        this.props.onChange('outletLongitude', outletLongitude)
      }, 1000);
    }

  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgOutletName,
      errMsgPhone,
      errMsgoutletOrderNotifyEmail,
      errMsgPostalCode,
      errMsgStatus = "";
    if ($validation.outletName.error.reason !== undefined) {
      errMsgOutletName = $validation.outletName.show && <span className="error">{$validation.outletName.error.reason}</span>;
    }
    if ($validation.outletPhone.error.reason !== undefined) {
      errMsgPhone = $validation.outletPhone.show && <span className="error">{$validation.outletPhone.error.reason}</span>;
    }
    if ($validation.outletOrderNotifyEmail.error.reason !== undefined) {
      errMsgoutletOrderNotifyEmail = $validation.outletOrderNotifyEmail.show && <span className="error">{$validation.outletOrderNotifyEmail.error.reason}</span>;
    }

    if ($validation.outletPostalCode.error.reason !== undefined) {
      errMsgPostalCode = $validation.outletPostalCode.show && <span className="error">{$validation.outletPostalCode.error.reason}</span>;
    }

    if ($validation.outletStatus.error.reason !== undefined) {
      errMsgStatus = $validation.outletStatus.show && <span className="error">{$validation.outletStatus.error.reason}</span>;
    }

    const companyPlans = cookie.load("companyPlans") ?? "";

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3 pt-5">
          <div className={`col-md-${fields.outletQRCodeImage !== "" && companyPlans.indexOf("EpicPay") >= 0 ? "9" : "12"}`}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className={errMsgOutletName !== "" && errMsgOutletName !== false && errMsgOutletName !== undefined ? "form-control is-invalid" : "form-control"}
                    name="outletName"
                    value={fields.outletName}
                    {...$field("outletName", (e) => onChange("outletName", e.target.value))}
                  />
                  <label htmlFor="outletName">
                    Outlet Name <span className="error">*</span>
                  </label>
                  {errMsgOutletName}
                </div>
              </div>
              {companyPlans.indexOf("Ecommerce") >= 0 && (
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline mb-4">
                    <input type="text" className="form-control" name="outletPOSID" value={fields.outletPOSID} {...$field("outletPOSID", (e) => onChange("outletPOSID", e.target.value))} />
                    <label htmlFor="outletPOSID">POS ID</label>
                  </div>
                </div>
              )}

              <div className="col-md-6">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className={errMsgPhone !== "" && errMsgPhone !== false && errMsgPhone !== undefined ? "form-control is-invalid" : "form-control"}
                    name="outletPhone"
                    id="outletPhone"
                    value={fields.outletPhone}
                    {...$field("outletPhone", (e) => onChange("outletPhone", e.target.value))}
                  />
                  <label htmlFor="outletPhone">Phone</label>
                  {errMsgPhone}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className={errMsgPhone !== "" && errMsgPhone !== false && errMsgPhone !== undefined ? "form-control is-invalid" : "form-control"}
                    name="outletOrderNotifyEmail"
                    id="outletOrderNotifyEmail"
                    value={fields.outletOrderNotifyEmail}
                    {...$field("outletOrderNotifyEmail", (e) => onChange("outletOrderNotifyEmail", e.target.value))}
                  />
                  <label htmlFor="outletOrderNotifyEmail">Order Notify Email</label>
                  {errMsgoutletOrderNotifyEmail}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className={errMsgPostalCode !== "" && errMsgPostalCode !== false && errMsgPostalCode !== undefined ? "form-control is-invalid" : "form-control"}
                    name="outletPostalCode"
                    id="outletPostalCode"
                    value={fields.outletPostalCode}
                    {...$field("outletPostalCode", (e) => onChange("outletPostalCode", e.target.value))}
                  />
                  <label htmlFor="outletPostalCode">
                    Postal Code<span className="error">*</span>
                  </label>
                  {errMsgPostalCode}
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="outletUnitNumber"
                    id="outletUnitNumber"
                    value={fields.outletUnitNumber}
                    {...$field("outletUnitNumber", (e) => onChange("outletUnitNumber", e.target.value))}
                  />
                  <label htmlFor="outletUnitNumber">Unit No.</label>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="outletFloorNumber"
                    id="outletFloorNumber"
                    value={fields.outletFloorNumber}
                    {...$field("outletFloorNumber", (e) => onChange("outletFloorNumber", e.target.value))}
                  />
                  <label htmlFor="outletFloorNumber">Floor No.</label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="outletAddress"
                    id="outletAddress"
                    value={fields.outletAddress}
                    {...$field("outletAddress", (e) => onChange("outletAddress", e.target.value))}
                  />
                  <label htmlFor="outletAddress">Address</label>
                </div>
              </div>
              {companyPlans.indexOf("Ecommerce") >= 0 && this.props.availabiltyList.length > 0 && (
                <>
                  <div className="col-md-6 mb-4">
                    <div className="form-floating form-floating-outline custm-select-box">
                      <Select
                        value={fields.outletAvailability}
                        onChange={this.handleSelectChange.bind(this, "outletAvailability")}
                        isMulti
                        placeholder="Select Availabilty"
                        options={this.props.availabiltyList}
                      />
                      <label className="select-box-label">Availabilty</label>
                    </div>
                  </div>

                  {fields.outletAvailability.length > 0 &&
                    fields.outletAvailability.map((item, index) => {
                      var slectedtat = [];
                      if (item.label.toLowerCase() === "delivery") {
                        slectedtat = fields.outletDeliveryTAT;
                      }
                      if (item.label.toLowerCase() === "pickup") {
                        slectedtat = fields.outletPickupTAT;
                      }
                      if (item.label.toLowerCase() === "dinein") {
                        slectedtat = fields.outletDineInTAT;
                      }
                      return (
                        <div className="col-md-3 mb-4" key={index}>
                          <div className="form-floating form-floating-outline custm-select-box">
                            <Select
                              value={slectedtat}
                              onChange={this.handleSelectChange.bind(this, "outlet" + item.label + "TAT")}
                              placeholder={"Select " + item.label + " TAT"}
                              options={this.props.tatList}
                            />
                            <label className="select-box-label">{item.label + " TAT"}</label>
                          </div>
                        </div>
                      );
                    })}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="outletSequence"
                        id="outletSequence"
                        value={fields.outletSequence}
                        {...$field("outletSequence", (e) => onChange("outletSequence", e.target.value))}
                      />
                      <label htmlFor="outletSequence">Sequence</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="outletPerdayLimit"
                        id="outletPerdayLimit"
                        value={fields.outletPerdayLimit}
                        {...$field("outletPerdayLimit", (e) => onChange("outletPerdayLimit", e.target.value))}
                      />
                      <label htmlFor="outletPerdayLimit">Order Limit Per Day</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="outletMapLink"
                        id="outletMapLink"
                        value={fields.outletMapLink}
                        {...$field("outletMapLink", (e) => onChange("outletMapLink", e.target.value))}
                      />
                      <label htmlFor="outletMapLink">Map Link</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="outletTimeInfo"
                        id="outletTimeInfo"
                        value={fields.outletTimeInfo}
                        {...$field("outletTimeInfo", (e) => onChange("outletTimeInfo", e.target.value))}
                      />
                      <label htmlFor="outletTimeInfo">Time Info</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="outletOfferInfo"
                        id="outletOfferInfo"
                        value={fields.outletOfferInfo}
                        {...$field("outletOfferInfo", (e) => onChange("outletOfferInfo", e.target.value))}
                      />
                      <label htmlFor="outletOfferInfo">Offer Info</label>
                    </div>
                  </div>
                  <div className="col-md-12 mb-4">
                    <div className="form-floating form-floating-outline custm-select-box ">
                      <Select
                        value={fields.outletTagID}
                        isMulti
                        onChange={this.handleSelectChange.bind(this, "outletTagID")}
                        placeholder="Select Tags"
                        options={this.props.tagList}
                        isClearable={true}
                      />
                      <label className="select-box-label">Tags</label>
                    </div>
                  </div>
                </>
              )}
              <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                <div className="form-floating form-floating-outline custm-select-box">
                  <Select
                    value={fields.outletStatus}
                    onChange={this.handleSelectChange.bind(this, "outletStatus")}
                    placeholder="Select Shop Opening Status"
                    options={[
                      { value: 1, label: "Open" },
                      { value: 0, label: "Closed" },
                    ]}
                  />
                  <label className="select-box-label">
                    Shop Opening Status<span className="error">*</span>
                  </label>
                  {errMsgStatus}
                </div>
              </div>
              {companyPlans.indexOf("EpicPay") >= 0 && (
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="text"
                      className="form-control"
                      name="outletPlaceID"
                      id="outletPlaceID"
                      value={fields.outletPlaceID}
                      {...$field("outletPlaceID", (e) => onChange("outletPlaceID", e.target.value))}
                    />
                    <label htmlFor="outletPlaceID">Google Review Place ID</label>
                    <strong>
                      For getting Place ID{" "}
                      <a href="https://developers.google.com/maps/documentation/places/web-service/place-id" target="_blank">
                        click here
                      </a>
                    </strong>
                  </div>
                </div>
              )}
            </div>
          </div>
          {companyPlans.indexOf("EpicPay") >= 0 && (
            <div className={`col-md-3 text-center mx-auto`}>
              {fields.outletQRCodeImage !== "" && (
                <>
                  <a href="/" download target="_blank" onClick={this.viewQRCode.bind(this, `outlet`)}>
                    <div className="d-flex align-items-center flex-column">
                      <div className="user-info text-center">
                        <span className="badge bg-label-primary">View Outlet QR Code</span>
                      </div>
                    </div>
                  </a>
                  <div className="input-group mt-2">
                    <input type="text" className="form-control" defaultValue={`${frontURL}${fields.outletslug}/directpay/${fields.outletQRCode}`} aria-describedby="basic-default-password42" />
                    <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, `${frontURL}${fields.outletslug}/directpay/${fields.outletQRCode}`)}>
                      <i className="mdi mdi-content-copy"></i>
                    </span>
                  </div>
                </>
              )}
              <br />
              <a href="/" download target="_blank" onClick={this.viewQRCode.bind(this, `review`)}>
                <div className="d-flex align-items-center flex-column">
                  <div className="user-info text-center">
                    <span className="badge bg-label-primary">View Review QR Code</span>
                  </div>
                </div>
              </a>
              <div className="input-group mt-2">
                <input type="text" className="form-control" defaultValue={`${frontURL}review/${fields.outletslug}`} aria-describedby="basic-default-password42" />
                <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, `${frontURL}review/${fields.outletslug}`)}>
                  <i className="mdi mdi-content-copy"></i>
                </span>
              </div>
              <br />
              <a href="/" download target="_blank" onClick={this.viewQRCode.bind(this, `whatsapp`)}>
                <div className="d-flex align-items-center flex-column">
                  <div className="user-info text-center">
                    <span className="badge bg-label-primary">View Whats APP QR Code</span>
                  </div>
                </div>
              </a>
              <div className="input-group mt-2">
                <input type="text" className="form-control" defaultValue={`${fields.outletWhatsAppURL}`} aria-describedby="basic-default-password42" />
                <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, `${fields.outletWhatsAppURL}`)}>
                  <i className="mdi mdi-content-copy"></i>
                </span>
              </div>
              <br />
              <a href="/" download target="_blank" onClick={this.viewQRCode.bind(this, `whatsappreview`)}>
                <div className="d-flex align-items-center flex-column">
                  <div className="user-info text-center">
                    <span className="badge bg-label-primary">View Whats APP Review QR Code</span>
                  </div>
                </div>
              </a>
              <div className="input-group mt-2">
                <input type="text" className="form-control" defaultValue={`${fields.outletWhatsAppReviewURL}`} aria-describedby="basic-default-password42" />
                <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, `${fields.outletWhatsAppReviewURL}`)}>
                  <i className="mdi mdi-content-copy"></i>
                </span>
              </div>
              <br />
              <a href="/" download target="_blank" onClick={this.viewQRCode.bind(this, `spinWheel`)}>
                <div className="d-flex align-items-center flex-column">
                  <div className="user-info text-center">
                    <span className="badge bg-label-primary">View Spin Wheel QR Code</span>
                  </div>
                </div>
              </a>
              <div className="input-group mt-2">
                <input type="text" className="form-control" defaultValue={`${fields.outletSpinWheelURL}`} aria-describedby="basic-default-password42" />
                <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, `${fields.outletSpinWheelURL}`)}>
                  <i className="mdi mdi-content-copy"></i>
                </span>
              </div>
            </div>
          )}

          <div className="col-md-12">
            <label>Outlet Information</label>
            <Editor data={fields.outletInformation} IDName={"editorContent"} />
          </div>
          {companyPlans.indexOf("EpicPay") >= 0 && (
            <>
              <div className="col-md-12"><div style={{ position: 'relative' }}><Googlemap onShapesUpdate={this.sateValChange.bind(this)} zoneCoordinationPoint={
                fields.outletLatitude && fields.outletLongitude
                  ? {
                    lat: parseFloat(fields.outletLatitude),
                    lng: parseFloat(fields.outletLongitude)
                  }
                  : null
              } /></div></div>
              <div className="col-md-6">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="outletValidateDistance"
                    id="outletValidateDistance"
                    value={fields.outletValidateDistance}
                    {...$field("outletValidateDistance", (e) => onChange("outletValidateDistance", e.target.value))}
                  />
                  <label htmlFor="outletValidateDistance">Validate Distance(in meters)</label>
                </div>
              </div>
              <div className="col-md-6"></div>
            </>
          )}


          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <div className="mb-3" id="ImageContainer">
                <label htmlFor="formFile" className="form-label">
                  Outlet Image
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="outletImage"
                  onChange={(event) => {
                    this.uplaodoutletImage("outletImage", event);
                    return false;
                  }}
                />
              </div>
            </div>
            {fields.outletImage !== "" && (
              <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                <div className="dz-details" id="ImageDetails">
                  <div className="dz-thumbnail">
                    <img alt="" src={fields.outletImage} />
                  </div>
                </div>
                <a className="dz-remove" href={"/"} onClick={this.removeImage.bind(this, fields.outletImage, "outletImage")}>
                  Remove file
                </a>
              </div>
            )}
          </div>

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
        <div className="modal fade" id="customermodal" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">
                  {(() => {
                    if (this.state.modleType === "review") {
                      return <div>Review QR Code</div>;
                    } else if (this.state.modleType === "whatsapp") {
                      return <div>Whats APP QR Code</div>;
                    } else if (this.state.modleType === "whatsappreview") {
                      return <div>Whats APP Review QR Code</div>;
                    } else if (this.state.modleType === "spinwheel") {
                      return <div>Spin Wheel QR Code</div>;
                    }  else if (this.state.modleType === "scratchcard") {
                      return <div>Scratch Card QR Code</div>;
                    } else {
                      return <div>Outlet QR Code</div>;
                    }
                  })()}
                </h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className=" mb-4">
                  <div className="card-body mt-3">
                    <div className="row">
                      <div className={`col-md-8 text-center mx-auto`}>
                        {fields.outletQRCodeImage !== "" && this.state.modleType === "outlet" && (
                          <>
                            <a href={fields.outletQRCodeImage} download target="_blank">
                              <div className="d-flex align-items-center flex-column">
                                <img src={fields.outletQRCodeImage} alt={fields.outletName} style={{ width: "50%" }} />
                                <div className="user-info text-center">
                                  <span className="badge bg-label-primary">Download</span>
                                </div>
                              </div>
                            </a>
                            <div className="input-group mt-2">
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={`${frontURL}${fields.outletslug}/directpay/${fields.outletQRCode}`}
                                aria-describedby="basic-default-password42"
                              />
                              <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, `${frontURL}${fields.outletslug}/directpay/${fields.outletQRCode}`)}>
                                <i className="mdi mdi-content-copy"></i>
                              </span>
                            </div>
                          </>
                        )}
                        <br />
                        {fields.outletReviewQR !== "" && this.state.modleType === "review" && (
                          <>
                            <a href={fields.outletReviewQR} download target="_blank">
                              <div className="d-flex align-items-center flex-column">
                                <img src={fields.outletReviewQR} alt={fields.outletName} style={{ width: "50%" }} />
                                <div className="user-info text-center">
                                  <span className="badge bg-label-primary">Downlaod</span>
                                </div>
                              </div>
                            </a>
                            <div className="input-group mt-2">
                              <input type="text" className="form-control" defaultValue={`${frontURL}review/${fields.outletslug}`} aria-describedby="basic-default-password42" />
                              <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, `${frontURL}review/${fields.outletslug}`)}>
                                <i className="mdi mdi-content-copy"></i>
                              </span>
                            </div>
                          </>
                        )}
                        {fields.outletWhatsAppQR !== "" && this.state.modleType === "whatsapp" && (
                          <>
                            <a href={fields.outletWhatsAppQR} download target="_blank">
                              <div className="d-flex align-items-center flex-column">
                                <img src={fields.outletWhatsAppQR} alt={fields.outletName} style={{ width: "50%" }} />
                                <div className="user-info text-center">
                                  <span className="badge bg-label-primary">Downlaod</span>
                                </div>
                              </div>
                            </a>
                            <div className="input-group mt-2">
                              <input type="text" className="form-control" defaultValue={`${fields.outletWhatsAppURL}`} aria-describedby="basic-default-password42" />
                              <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, `${fields.outletWhatsAppURL}`)}>
                                <i className="mdi mdi-content-copy"></i>
                              </span>
                            </div>
                          </>
                        )}
                        {fields.outletWhatsAppReviewQR !== "" && this.state.modleType === "whatsappreview" && (
                          <>
                            <a href={fields.outletWhatsAppReviewQR} download target="_blank">
                              <div className="d-flex align-items-center flex-column">
                                <img src={fields.outletWhatsAppReviewQR} alt={fields.outletName} style={{ width: "50%" }} />
                                <div className="user-info text-center">
                                  <span className="badge bg-label-primary">Downlaod</span>
                                </div>
                              </div>
                            </a>
                            <div className="input-group mt-2">
                              <input type="text" className="form-control" defaultValue={`${fields.outletWhatsAppReviewURL}`} aria-describedby="basic-default-password42" />
                              <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, `${fields.outletWhatsAppReviewURL}`)}>
                                <i className="mdi mdi-content-copy"></i>
                              </span>
                            </div>
                          </>
                        )}
                        {fields.outletSpinWheelQR !== "" && this.state.modleType === "spinWheel" && (
                          <>
                            <a href={fields.outletSpinWheelQR} download target="_blank">
                              <div className="d-flex align-items-center flex-column">
                                <img src={fields.outletSpinWheelQR} alt={fields.outletName} style={{ width: "50%" }} />
                                <div className="user-info text-center">
                                  <span className="badge bg-label-primary">Downlaod</span>
                                </div>
                              </div>
                            </a>
                            <div className="input-group mt-2">
                              <input type="text" className="form-control" defaultValue={`${fields.outletSpinWheelURL}`} aria-describedby="basic-default-password42" />
                              <span className="input-group-text cursor-pointer" onClick={this.copyLink.bind(this, `${fields.outletSpinWheelURL}`)}>
                                <i className="mdi mdi-content-copy"></i>
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
Postform = validated(validationConfig)(Postform);
